import React, { Component } from 'react';
import TableTabs from './../../Global/Modules/TableTabs'

class CursusInformatie extends Component {

  render() {
    return (
      <div className="route">
        <h1 className="pageTitle">
          Cursusinformatie
          </h1>
        <TableTabs />
      </div>
    );
  }
}

export default CursusInformatie;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Cursus-informatie.js